import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderPaper: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="folder-paper"><path d="M16.25 5.75H20.25V10.75M3.75 7.75V3.75H16.25V10.75M3.75 7.75H2.75V20.25H21.25V10.75H20.25M3.75 7.75H8.75L11.75 10.75H16.25M16.25 10.75H20.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconFolderPaper;
